module.exports = __webpack_public_path__ + "img/banner.6b7a0981.png";